import { updatePushNotificationToken } from "@api/Rest/pushNotification";
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  isSupported,
  type MessagePayload,
  onMessage,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyADVAYOHtTTMkrlXTfXZ0IYS6KuOK62CH8",
  authDomain: "alb-messaging.firebaseapp.com",
  projectId: "alb-messaging",
  storageBucket: "alb-messaging.appspot.com",
  messagingSenderId: "668075662563",
  appId: "1:668075662563:web:2d22e190ad8d261cb2f9d6",
  measurementId: "G-MN17SVDRJ6",
};

const app = initializeApp(firebaseConfig);

let _messaging: ReturnType<typeof getMessaging> | null = null;

function getMessagingInstance() {
  if (!_messaging) _messaging = getMessaging(app);
  return _messaging;
}

// TODO: Refactor this function to handle token creation and updating more cleanly
export type PermissionSetupStatus = "granted" | "denied" | "failed" | "unsupported";

async function requestPermission(): Promise<PermissionSetupStatus> {
  if (!(await isSupported())) return "unsupported";
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      console.log("Notification permission granted.");
      let currentToken: string | null = null;
      try {
        const messaging = getMessagingInstance();
        currentToken =
          (await getToken(messaging, {
            vapidKey: `BEcdCOftbNEtAyLhzrowTLJ_dl7OjJj7-OeWWDHx5O48lB0dWfrbMD1cIWhmoXP_bW6EKiI5Z2Sy3apo5MIQDhY`,
          })) ?? null;
      } catch (tokenError) {
        console.error("Error getting FCM token:", tokenError);
      }

      if (currentToken) {
        try {
          await updatePushNotificationToken({
            token: currentToken,
          });
        } catch (saveError) {
          // Backend save failed: token exists locally but this browser will
          // not receive pushes. Report it so the UI can warn loudly.
          console.error("Error saving push notification token:", saveError);
          return "failed";
        }
        localStorage.setItem("pushToken", JSON.stringify({ token: currentToken }));
        return "granted";
      }
      console.log("Failed to generate the app registration token.");
      return "failed";
    }
    console.log("Unable to get permission to notify.");
    return "denied";
  } catch (error) {
    console.log("An error occurred while requesting permission.", error);
    return "failed";
  }
}

// Event-based FCM message subscription for persistent notification handling
function subscribeToMessages(callback: (payload: MessagePayload) => void) {
  try {
    const messaging = getMessagingInstance();
    return onMessage(messaging, callback);
  } catch {
    // Unsupported browser (Safari Private, etc.)
    return undefined;
  }
}

export { requestPermission, subscribeToMessages };
